import {Grid, SxProps} from '@mui/material';

import {Loading} from './Loading';

interface Props {
  minHeight: string;
  sx?: SxProps;
}

export const LoadingContainer = ({minHeight, sx}: Props) => {
  return (
    <Grid
      container
      display='flex'
      minHeight={minHeight}
      width='100%'
      justifyContent='center'
      flexDirection='column'
      alignItems='center'
      sx={sx}
    >
      <Loading />
    </Grid>
  );
};
